import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { Store } from "@ngxs/store";
import { Logout } from "@store/auth/auth.actions";
import { LoadSleepers } from "@store/sleepers/sleepers.actions";
import { SleepersSelectors } from "@store/sleepers/sleepers.selectors";
import { catchError, map, of } from "rxjs";

export const SleepersGuard: CanActivateFn = () => {
  const store = inject(Store);
  if (store.selectSnapshot(SleepersSelectors.sleepers)?.length === 0) {
    return store.dispatch(new LoadSleepers()).pipe(
      map(() => true), // Return true when sleepers are loaded
      catchError(() => {
        store.dispatch(new Logout()); // Log out the user on error
        return of(false); // Return false to indicate failure
      })
    );
  } else {
    return of(true); // Return true if sleepers are already available
  }
};
